import { getHandlingError } from '../helper/utils/utilsHelperStatus';
import { api, apiUpload } from './config';

const fetcher = {
    get: (url, payload = null) =>
        api
            .get(url, payload)
            .then((res) => res.data)
            .catch(getHandlingError),

    post: (url, payload) =>
        api
            .post(url, payload)
            .then((res) => res.data)
            .catch(getHandlingError),

    put: (url, payload) =>
        api
            .put(url, payload)
            .then((res) => res.data)
            .catch(getHandlingError),

    delete: (url, payload = null) =>
        api
            .delete(url, payload)
            .then((res) => res.data)
            .catch(getHandlingError),

    postUpload: (url, payload) =>
        apiUpload
            .post(url, payload)
            .then((res) => res.data)
            .catch(getHandlingError),

    patch: (url, payload) =>
        api
            .patch(url, payload)
            .then((res) => res.data)
            .catch(getHandlingError),
};

export default fetcher;
